var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", [
    _c("div", { staticClass: "footerlogos" }, [
      _c("div", { staticClass: "footerlogo-left" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footercontact" },
          [
            _vm._v(
              "\n                601 South Prospect Street, Galena, Illinois 61036, USA"
            ),
            _c("BR"),
            _vm._v(" "),
            _c("strong", [_vm._v("Tel:")]),
            _vm._v(" +1 815 777 4444 "),
            _c("strong", [_vm._v("E-mail:")]),
            _vm._v(
              " contact@globaldesignnews.com, orders@metropolitanartspress.com"
            ),
            _c("BR"),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.globaldesignnews.com",
                  target: "_blank",
                },
              },
              [_vm._v("globaldesignnews.com")]
            ),
            _vm._v(" | "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.metropolitanartspress.com",
                  target: "_blank",
                },
              },
              [_vm._v("metropolitanartspress.com")]
            ),
            _vm._v(" | "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.instagram.com/globaldesignnews/",
                  target: "_blank",
                },
              },
              [_vm._v("Instagram")]
            ),
            _vm._v(" | "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.facebook.com/globaldesignnews",
                  target: "_blank",
                },
              },
              [_vm._v("Facebook")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footerlogo-right" }, [_vm._t("default")], 2),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { attrs: { href: "https://www.globaldesignnews.com", target: "_blank" } },
      [_c("img", { attrs: { src: "/images/gdn-logo.svg" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }